import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
// import { useSelector } from "react-redux";

import {
  SignUpRoute,
  SignUpSuccessRoute,
  VerifyRoutes,
  InviteRoute,
  ResetPasswordRoute,
  ForgotPasswordRoute,
  ConfirmPasswordRoute,
  SuccessForgotPasswordRoute,
  SignInRoute,
} from 'views/Auth';
// import { RootState } from "redux-modules/store/rootState";
import { NotFoundRoute } from 'views/NotFound/Routes';
import { DashboardRoute } from 'views/Dashboard/Routes';
import { InvestmentDetailsRoute } from 'views/InvestmentDetails/Routes';
import { InvestNowRoute } from 'views/InvestNow/Routes';
import { PortfolioRoute } from 'views/Portfolio/Routes';
import { TransactionsRoute } from 'views/Transactions/Routes';
import { ReferRoute } from 'views/ReferAndEarn/Routes';
import { ProfileRoute } from 'views/Profile/Routes';
import { SettingsRoute } from 'views/Settings/Routes';
import { DocusignStatusRoute } from 'views/DocusignStatus/Routes';
import { InvestmentBulkRoute } from 'views/InvestmentBulk/Routes';

import AuthenticatedRouteWrapper from './layouts/AuthenticatedRouteWrapper';
import PublicRouteWrapper from './layouts/PublicRouteWrapper';
import { IRoute } from './common/types';

const Routes = () => {
  // const { role } = useSelector(({ Auth }: RootState) => Auth.user);

  const PublicRoutes = [
    SignInRoute,
    SignUpRoute,
    ResetPasswordRoute,
    SignUpSuccessRoute,
    VerifyRoutes,
    ForgotPasswordRoute,
    ConfirmPasswordRoute,
    SuccessForgotPasswordRoute,
    InviteRoute,
    DocusignStatusRoute,
  ];

  const Investor = [
    NotFoundRoute,
    DashboardRoute,
    InvestmentDetailsRoute,
    InvestNowRoute,
    PortfolioRoute,
    TransactionsRoute,
    ProfileRoute,
    ReferRoute,
    SettingsRoute,
    InvestmentBulkRoute,
  ];

  return (
    <Switch>
      {PublicRoutes.map((route: IRoute, index: number) => (
        <PublicRouteWrapper key={`public-route-wrapper-${index}`} {...route} />
      ))}
      {Investor.map((route: IRoute, index: number) => (
        <AuthenticatedRouteWrapper
          key={`auth-route-wrapper-${index}`}
          {...route}
        />
      ))}
      <Redirect exact path="/" to="/dashboard" />
      <Redirect exact to="/not-found" />
    </Switch>
  );
};

export default Routes;
